import React, { useState, useEffect } from 'react';
import { ShieldExclamationIcon, LockClosedIcon, ArrowRightOnRectangleIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';

const SecurityBanner: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const acknowledged = sessionStorage.getItem('securityBannerAcknowledged');
    if (!acknowledged) {
      setShow(true);
    }
  }, []);

  const handleAcknowledge = () => {
    sessionStorage.setItem('securityBannerAcknowledged', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative max-w-2xl w-full mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 px-6 py-5 flex items-center gap-3">
          <ShieldExclamationIcon className="h-8 w-8 text-white flex-shrink-0" />
          <div>
            <h2 className="text-lg font-bold text-white">
              Információbiztonsági figyelmeztetés
            </h2>
            <p className="text-sm text-red-100">
              Kérjük, figyelmesen olvassa el a munkavégzés megkezdése előtt
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-900 font-medium">
              Ez a rendszer bizalmas információkat tartalmaz. Az illetéktelen hozzáférés, adatfelhasználás vagy adatkezelés törvényi szankciókkal járhat.
            </p>
          </div>

          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <LockClosedIcon className="h-5 w-5 text-gray-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700">
                <strong>Adatbiztonság:</strong> A rendszerben kezelt adatok bizalmasak. Az adokat csak a munkakörében előírt célokra használhatja fel. Az adatok másolása, továbbítása vagy harmadik féllel való megosztása szigorúan tilos.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <ArrowRightOnRectangleIcon className="h-5 w-5 text-gray-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700">
                <strong>Kilépés a munkamenetből:</strong> Ha befejezte a munkamenetet, mindig jelentkezzen ki a rendszerből. Soha ne hagyja a számítógépet őrizetlenül bejelentkezett állapotban.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <ComputerDesktopIcon className="h-5 w-5 text-gray-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700">
                <strong>Gép őrizetlenül hagyása:</strong> Ne hagyja a számítógépet felügyelet nélkül, amíg be van jelentkezve a rendszerbe. Ha rövid időre is el kell hagynia a munkaállomást, zárolja a képernyőt vagy jelentkezzen ki.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
            <p className="text-xs text-gray-600">
              A rendszer használatával Ön elismeri, hogy elolvasta és megértette a fenti biztonsági előírásokat, és vállalja azok betartását. A szabályok megsértése fegyelmi és jogi következményekkel járhat.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
          <button
            onClick={handleAcknowledge}
            className="px-6 py-2.5 bg-gradient-to-r from-red-600 to-red-700 text-white font-medium rounded-lg hover:from-red-700 hover:to-red-800 transition-all shadow-md"
          >
            Megértettem, folytatás
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecurityBanner;
